const VARIANT_CLASSES: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-700',
  published: 'bg-green-100 text-green-700',
  archived: 'bg-yellow-100 text-yellow-700',
  in_progress: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
};

interface StatusBadgeProps {
  status: string;
}

export function StatusBadge({ status }: StatusBadgeProps): React.JSX.Element {
  const classes = VARIANT_CLASSES[status] ?? 'bg-gray-100 text-gray-700';
  const DISPLAY_LABELS: Record<string, string> = { archived: 'inactive' };
  const label = DISPLAY_LABELS[status] ?? status.replace('_', ' ');

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${classes}`}
    >
      {label}
    </span>
  );
}
